/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    GlobalDeviceStatusResponse,
    GlobalUptimeResponse,
} from "../models/index";
import {
    GlobalDeviceStatusResponseFromJSON,
    GlobalDeviceStatusResponseToJSON,
    GlobalUptimeResponseFromJSON,
    GlobalUptimeResponseToJSON,
} from "../models/index";

export interface GlobalDeviceConnectorStatusRequest {
    deviceGroupTags?: Array<string>;
    includeNonOpChargers?: boolean;
    isIntersection?: boolean;
}

export interface GlobalDeviceGroupUpTimeRequest {
    deviceGroupTags?: Array<string>;
}

export interface GlobalDeviceStatusRequest {
    deviceGroupTags?: Array<string>;
    includeNonOpChargers?: boolean;
    isIntersection?: boolean;
}

/**
 *
 */
export class GlobalDashboardHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Get a count of ALL device connectors by status. Intended for the System Health dashboard.
     */
    async globalDeviceConnectorStatusRaw(
        requestParameters: GlobalDeviceConnectorStatusRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<GlobalDeviceStatusResponse>> {
        const queryParameters: any = {};

        if (requestParameters["deviceGroupTags"] != null) {
            queryParameters["deviceGroupTags"] = requestParameters[
                "deviceGroupTags"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters["includeNonOpChargers"] != null) {
            queryParameters["includeNonOpChargers"] =
                requestParameters["includeNonOpChargers"];
        }

        if (requestParameters["isIntersection"] != null) {
            queryParameters["isIntersection"] =
                requestParameters["isIntersection"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/global-dashboard/device-status/connectors`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            GlobalDeviceStatusResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get a count of ALL device connectors by status. Intended for the System Health dashboard.
     */
    async globalDeviceConnectorStatus(
        requestParameters: GlobalDeviceConnectorStatusRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<GlobalDeviceStatusResponse> {
        const response = await this.globalDeviceConnectorStatusRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get uptime of devices online in the past 30 days for a site / organisation. Also includes percentage diff from previous 30 days. NOTE: Passthrough devices are not included.
     */
    async globalDeviceGroupUpTimeRaw(
        requestParameters: GlobalDeviceGroupUpTimeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<GlobalUptimeResponse>>> {
        const queryParameters: any = {};

        if (requestParameters["deviceGroupTags"] != null) {
            queryParameters["deviceGroupTags"] = requestParameters[
                "deviceGroupTags"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/global-dashboard/global-device-uptime`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(GlobalUptimeResponseFromJSON),
        );
    }

    /**
     * Get uptime of devices online in the past 30 days for a site / organisation. Also includes percentage diff from previous 30 days. NOTE: Passthrough devices are not included.
     */
    async globalDeviceGroupUpTime(
        requestParameters: GlobalDeviceGroupUpTimeRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<GlobalUptimeResponse>> {
        const response = await this.globalDeviceGroupUpTimeRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get a count of ALL non-virtual ChargePoint devices by status. Intended for the System Health dashboard.
     */
    async globalDeviceStatusRaw(
        requestParameters: GlobalDeviceStatusRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<GlobalDeviceStatusResponse>> {
        const queryParameters: any = {};

        if (requestParameters["deviceGroupTags"] != null) {
            queryParameters["deviceGroupTags"] = requestParameters[
                "deviceGroupTags"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters["includeNonOpChargers"] != null) {
            queryParameters["includeNonOpChargers"] =
                requestParameters["includeNonOpChargers"];
        }

        if (requestParameters["isIntersection"] != null) {
            queryParameters["isIntersection"] =
                requestParameters["isIntersection"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/global-dashboard/device-status`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            GlobalDeviceStatusResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get a count of ALL non-virtual ChargePoint devices by status. Intended for the System Health dashboard.
     */
    async globalDeviceStatus(
        requestParameters: GlobalDeviceStatusRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<GlobalDeviceStatusResponse> {
        const response = await this.globalDeviceStatusRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
